// extracted by mini-css-extract-plugin
export default {"root":"RoleCard_root__hz5e6","rightContainer":"RoleCard_rightContainer__HtaLq","buttonContainer":"RoleCard_buttonContainer__+uC1B","progress":"RoleCard_progress__iJaIT"};